import type { NameConfig } from '@libs/items';
import { l10nText } from '@ps-smart-cp/l10n';
import { rawValueToEnum } from '../utils';

/** 任意項目の長さ属性 */
enum OptionItemLength {
  fixedLength = '1',
  variableLength = '2',
}

const nameConfig: NameConfig<typeof OptionItemLength> = {
  fixedLength: l10nText({ ja: '固定長', en: 'Has Admin' }),
  variableLength: l10nText({ ja: '可変長', en: 'Not Admin' }),
};

const toEnum = rawValueToEnum(OptionItemLength, '');

export const optionItemLength = {
  enum: OptionItemLength,
  nameConfig,
  toEnum,
};
export type { OptionItemLength };
